











































import { Vue, Component } from "vue-property-decorator";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";

import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import BaseAlert from "@/components/BaseAlert/BaseAlert.vue";
import VideoListItem from "@/components/GrammarToGo/VideoListItem.vue";

import { Action, State } from "vuex-class";
import { IVuexState } from "@/models/interfaces/store";
import { IGrammarVideo } from "@/models/interfaces/grammar-to-go";
import RequestState from "@/utils/mixins/RequestState";
import amplitude from "amplitude-js";

@Component({
  components: {
    AppContent,
    AppHeaderBackWithTitle,
    AppHeader,

    BaseSpinner,
    BaseAlert,

    VideoListItem
  },
  mixins: [RequestState]
})
export default class VideosList extends Vue {
  @State("videos", { namespace: "grammarToGo" })
  private videos!: IVuexState<Array<IGrammarVideo[]>>;

  @Action("grammarToGo/fetchVideos")
  private fetchVideos!: () => Promise<any>;

  private viewVideo(video: IGrammarVideo) {
    amplitude
      .getInstance()
      .logEvent(`User clicks on Grammar to go video ${video.videoName}`);

    this.$router.push({
      path: `/video/${video.videoId}`,
      query: {
        title: video.videoName
      }
    });
  }

  public mounted() {
    this.fetchVideos();
  }
}
